import React from 'react';
import { PropTypes as PT } from 'prop-types';
import Measure from 'react-measure';
import _compact from 'lodash/compact';
import CallOverlaySlide from 'containers/InCall/CallOverlaySlide/CallOverlaySlideContainer';
import CallVideo from 'containers/InCall/CallVideo/CallVideoContainer';
import CallPresentation from 'containers/InCall/CallPresentation/CallPresentationContainer';
import Turtle from 'containers/InCall/Turtle/TurtleContainer';
import classes from './CallLayout.module.scss';

class CallLayout extends React.Component {
  handleDoubleClick = (e) => {
    e.preventDefault();

    if (this.props.isMinimized) {
      this.props.toggleMinimized();
    }
  };

  render() {
    const {
      showLocalConferenceSlides,
      hasSlide,
      hasVideo,
      isMinimized,
      inlinePresentation,
      handleResizeContainer,
      callLayoutId
    } = this.props;
    const containerClasses = _compact([
      classes.container,
      isMinimized ? classes.minimized : '',
      inlinePresentation && hasVideo && !isMinimized ? classes.dualStream : ''
    ]).join(' ');

    return (
      <Measure
        bounds
        onResize={container => handleResizeContainer(container.bounds)}
      >
        {({ measureRef }) =>
          <div
            ref={measureRef}
            className={containerClasses}
            id={callLayoutId}
            onDoubleClick={this.handleDoubleClick}
          >
            <CallPresentation />
            {showLocalConferenceSlides && hasSlide ? (
              <CallOverlaySlide />
            ) : null}
            <CallVideo />
            <Turtle />
          </div>
        }
      </Measure>
    );
  }
}

CallLayout.propTypes = {
  showLocalConferenceSlides: PT.bool.isRequired,
  hasSlide: PT.bool.isRequired,
  hasVideo: PT.bool.isRequired,
  isMinimized: PT.bool.isRequired,
  toggleMinimized: PT.func.isRequired,
  inlinePresentation: PT.bool,
  handleResizeContainer: PT.func,
  callLayoutId: PT.string
};

export default CallLayout;
